import { v4 as uuidv4 } from 'uuid';
const STAGING = 'https://v2.staging-spot.im/api/extract/cloudinary/sign';
const PRODUCTION = 'https://www.spot.im/api/extract/cloudinary/sign';
const CLOUDINARY_UPLOAD = 'https://api.cloudinary.com/v1_1/com-3pix/image/upload';
const API_KEY = '281466446316913';
const LIMIT = 100 * 1000; // 100kb
export function createUploadImage(params) {
    const { isProduction, optimizedUpload = true, lowQualityLimit = 15, fileSizeLimit = LIMIT } = params;
    async function uploadImage(image, size, publicId = uuidv4()) {
        let quality;
        if (optimizedUpload && size !== undefined && size > LIMIT) {
            quality = Math.floor(100 / (size / LIMIT));
            quality = Math.max(quality, lowQualityLimit);
        }
        const transformation = quality ? { transformation: `q_${quality}` } : {};
        const signParams = {
            public_id: publicId,
            timestamp: new Date().getTime() / 1000,
            ...transformation,
        };
        const { signature } = await sign(signParams);
        const uploadParams = { ...signParams, signature, file: image, api_key: API_KEY };
        const res = await fetch(CLOUDINARY_UPLOAD, getFetchInit(uploadParams));
        return await res.json();
    }
    async function sign(signParams) {
        const url = isProduction ? PRODUCTION : STAGING;
        const response = await fetch(url, getFetchInit({ cloudinary_params: signParams }));
        const result = await response.json();
        return result;
    }
    return uploadImage;
}
function getFetchInit(body) {
    return {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        body: JSON.stringify(body),
    };
}
